/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { LinkModule } from '@ng-falcon/navigation/link/link.module';
import { NgfButtonDirective } from '@ng-falcon/button/ngf-button/ngf-button.directive';
import { CollapsedPillsDirective } from './pill-list/collapsed-pills.directive';
import { PillListComponent } from './pill-list/pill-list.component';
import { PillComponent } from './pill.component';

@NgModule({
  imports: [
    A11yModule,
    CommonModule,
    MatIconModule,
    OverlayModule,
    LinkModule,
    NgfButtonDirective
  ],
  declarations: [
    PillComponent,
    PillListComponent,
    CollapsedPillsDirective,
  ],
  exports: [
    PillComponent,
    PillListComponent,
    CollapsedPillsDirective,
  ]
})
export class PillModule {}
